import React, { useEffect, useState } from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from '@mui/system';
import CategoryCheckbox from './CategoryCheckbox';
import { useTranslation } from 'react-i18next';

const CategoryAccordion = ({ setCategory, categories }) => {

    const { t, i18n } = useTranslation(['translation']);

    //console.log(categories.length < 12 ? 'panel1' : false)

    const [expanded, setExpanded] = useState('panel1');

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Box sx={{ width: {xs:300, lg:350} }} paddingTop='20px' paddingBottom='10px' className='visidea-visualsearch__filter-category'>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography sx={{ color: 'text.secondary' }}>{t('Category')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                   <CategoryCheckbox setCategory={setCategory} labels={categories}/>
                </AccordionDetails>
            </Accordion>
        </Box>
    );

}

export default CategoryAccordion